<template>
	<div class="container">
		<div class="iv2-page__maintenance">
			<h1 class="iv2-page__maintenance-title">{{ title }}</h1>
			<h2 class="iv2-page__maintenance-lead">{{ lead_text }}</h2>
			<div class="row clearfix">
				<div class="column full" style="margin: 0 auto;">
					<div style="text-align: center;">
						<span>
							<router-link
								to="/"
								class="iv2-page__maintenance-btn theme__main-btn is-btn is-btn-ghost2 is-upper"
							>{{ btn_text }}</router-link>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			title: "公開準備中",
			lead_text: "このページはただいま公開準備中です。",
			btn_text: "トップページに戻る",
		};
	},
};
</script>

<style lang="scss">
.iv2-page__maintenance {
	padding-top: 10rem;

	.iv2-page__maintenance-title {
		text-align: center;
		padding: 0 2rem;
		font-size: 4.5rem;
	}

	.iv2-page__maintenance-lead {
		text-align: center;
		font-size: 1.5rem;
		font-weight: 600;
		padding: 2rem 1rem;
		margin: 0;
	}

	.iv2-page__maintenance-btn {
		border: 0;
		border-radius: 50px;
		font-size: 18px;
		letter-spacing: 2px;
		padding-top: 15px;
		padding-bottom: 15px;
		width: 300px;
		max-width: 100%;
	}
}

@media (max-width: 1199px) {
	.iv2-page__maintenance {
		height: 80vh;

		.iv2-page__maintenance-title {
			font-size: 3rem;
		}

		.iv2-page__maintenance-lead {
			font-size: 1rem;
		}
	}
}

@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-page__maintenance {
		padding: 14rem 0;
	}
}
</style>